import * as React from 'react';
import { DropdownMenuItem } from '@symphony-ui/uitoolkit-components';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerRequest from 'models/ApiServerRequest';
import { sendFetchError } from 'utils/messageUtils';
import EmailTemplate from '../../models/EmailTemplate';
import UserContext from 'contexts/UserContext';
import PopupButton from 'components/custom-table/action/PopupButton';
import EmailSettingsModal from './EmailSettingsModal';
import EmailSettingsSaveModal from './EmailSettingsSaveModal';
const EmailSettingsButton = ({ current, setCurrent, original, setOriginal, }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const { checkEditable } = React.useContext(UserContext);
    const [showEmailSettingsModal, setShowEmailSettingsModal] = React.useState(false);
    const [showEmailSettingsSaveModal, setShowEmailSettingsSaveModal] = React.useState(false);
    const saveSettings = React.useCallback(() => {
        (async () => {
            const init = { body: JSON.stringify(current), headers: { 'Content-Type': 'application/json' }, method: 'POST' };
            const request = new ApiServerRequest('/syndicate/email-template', init);
            try {
                const body = await apiFetchJson(request);
                const updated = new EmailTemplate(body);
                setCurrent(updated);
                setOriginal(updated);
            }
            catch (error) {
                sendFetchError('Unable to save table settings', error, request);
            }
        })();
    }, [apiFetchJson, current, setCurrent, setOriginal]);
    const childFn = React.useCallback((close) => {
        const list = [
            (React.createElement(DropdownMenuItem, { key: "view", onClick: () => {
                    setShowEmailSettingsModal(true);
                    close();
                } }, "View Email Templates")),
            (React.createElement(DropdownMenuItem, { key: "saveSettings", onClick: () => {
                    setShowEmailSettingsSaveModal(true);
                    close();
                } }, current.id === undefined ? 'Save current Settings' : 'Save a Copy'))
        ];
        if (original !== undefined && checkEditable(current) && !current.equals(original))
            list.push((React.createElement(DropdownMenuItem, { key: "updateSettings", onClick: () => {
                    saveSettings();
                    close();
                } }, "Update current Settings")));
        return list;
    }, [checkEditable, current, original, saveSettings]);
    const deleteFn = React.useCallback((cellContext) => {
    }, []);
    const openFn = React.useCallback((cellContext) => {
    }, []);
    return (React.createElement(React.Fragment, null,
        showEmailSettingsSaveModal
            ? (React.createElement(EmailSettingsSaveModal, { close: () => setShowEmailSettingsSaveModal(false), emailTemplate: current, setEmailTemplate: setCurrent })) : undefined,
        showEmailSettingsModal
            ? (React.createElement(EmailSettingsModal, { close: () => setShowEmailSettingsModal(false), deleteFn: deleteFn, openFn: openFn })) : undefined,
        React.createElement(PopupButton, { childFn: childFn, iconName: "settings", style: { transform: 'translate(-9rem, -0.5rem)' } })));
};
export default EmailSettingsButton;
